export const HISTORY_PATH = {
  ORDER: '/history/order',
  DELIVERY: '/history/delivery',
  SHIPPING_SCHEDULE: '/history/shipping',
};
